/* eslint-disable no-param-reassign */
// @flow
import type { Node } from 'react';

import React from 'react';
import styled from 'styled-components';

import spacingUnits from './spacing';

type FillProps =
  | {|
      /**
       * The keyword string "viewport" or "parent".
       */
      width: 'viewport' | 'parent',
      /**
       * The keyword string "viewport" or "parent".
       */
      height: 'viewport' | 'parent',
      children: Node,
      /**
       * Should your theme's standard spacing be added?
       */
      spacing?: string,
    |}
  | {|
      width: 'viewport' | 'parent',
      children: Node,
      spacing?: string,
    |}
  | {|
      height: 'viewport' | 'parent',
      children: Node,
      spacing?: string,
    |}
  | {|
      /**
       * The keyword string "viewport" or "parent". Equivalent to setting the
       * `height` and `width` properties to the same keyword.
       */
      to: 'viewport' | 'parent',
      children: Node,
      spacing?: string,
    |};

type Props = {
  width: 'viewport' | 'parent' | void,
  height: 'viewport' | 'parent' | void,
  spacing: string,
};

function addPaddingCalc(str: string, padding: string): string {
  if (padding === '') {
    return str;
  }
  return `calc(${str} - 2 * ${padding})`;
}
function mapToCssValue(keyword: 'viewport' | 'parent' | void, padding: string, dim: 'h' | 'w') {
  switch (keyword) {
    case 'viewport':
      return addPaddingCalc(`100v${dim}`, padding);
    case 'parent':
      return addPaddingCalc('100%', padding);
    default:
      return 'unset';
  }
}

const StyledFill = styled.div`
  ${({ spacing }: Props) => (spacing ? `padding: ${spacingUnits[spacing]}` : '')};
  width: ${({ width, spacing }: Props) =>
    mapToCssValue(width, spacing && spacingUnits[spacing], 'w')};
  height: ${({ height, spacing }: Props) =>
    mapToCssValue(height, spacing && spacingUnits[spacing], 'h')};
  > * {
    ${({ width }: Props) => width && 'width: 100%;'} ${({ height }: Props) =>
      height && 'height: 100%;'};
  }
`;

/**
 * Utility component that causes its children to expand and fill either the
 * viewport or their parents.
 *
 * You can use the `to` property to fill both width and height to the same
 * target (`"viewport"` or `"parent"`), or specify them separately as
 * `width` and `height`.
 */
export default function Fill({
  // $FlowFixMe - it's fine
  width,
  // $FlowFixMe - it's fine
  height,
  // $FlowFixMe - it's fine
  to,
  children,
  spacing,
}: FillProps) {
  return (
    <StyledFill spacing={spacing} width={width || to} height={height || to}>
      {children}
    </StyledFill>
  );
}

Fill.defaultProps = {
  spacing: '',
};
